/**
 * Can this ONDO id be given this capacity over this subject? A question, not a search.
 */
import type {
  EligibilityRequest,
  EligibilityResponse,
} from "@ondo/shared";

import { request } from "./request.ts";

/**
 * Can this ONDO id be given this capacity over this subject?
 *
 * POST, though it writes nothing: the body names an ONDO id and a subject, and
 * neither belongs in a URL that lands in access logs, browser history and
 * referrer headers. Every verdict is a 200 — a check is a question, and
 * answering "no" is not a fault. The only 4xx is a subject the caller does not
 * hold, which is a refusal to answer at all.
 */
export const checkEligibility = (body: EligibilityRequest) =>
  request<EligibilityResponse>("/eligibility", body);
